import { useQuery } from '@apollo/client';
import { query } from './query';
export const usePendingInvites = () => useQuery(query);
